import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { PortalContatoClientes } from '@/domain/usecases'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols/http'

export class RemoteGetPortalContatosClientes implements PortalContatoClientes {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<PortalContatoClientes.Result>
  ) {}

  async get (params: PortalContatoClientes.Params): Promise<PortalContatoClientes.Result> {
    const authParams: HttpRequest = {
      url: `${this.url}/api/portal/contatos/clientes`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(authParams)

    switch (statusCode) {
      case HttpStatusCode.ok: {
        if (body === null) {
          throw new UnexpectedResultFormatError()
        }
        return body
      }
      case HttpStatusCode.badRequest: throw new UnexpectedError()
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
